import { Button } from '@creditornot/cb-button';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import HighFiveHands from 'common/illustrations/HighFiveHands';
import { Typography as T } from 'common/typography';

import { BREAKPOINT_MOBILE } from '../constants';

const Heading = styled(T.Heading1)`
  text-align: center;
`;

const Subheading = styled(T.Heading6)`
  text-align: center;
  font-weight: 400;
`;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 620px;
  height: 80%;
  margin: 0 auto;
  padding-inline: 16px;

  ${Heading} {
    margin-block-start: 32px;
    font-size: 48px;

    @media (max-width: ${BREAKPOINT_MOBILE}px) {
      font-size: 40px;
    }
  }

  ${Subheading} {
    margin-block-start: 16px;
    margin-block-end: 16px;
    font-size: 20px;

    @media (min-width: ${BREAKPOINT_MOBILE}px) {
      font-size: 20px;
    }
  }
`;

const Thanks = () => {
  const history = useHistory();

  return (
    <Root>
      <HighFiveHands width={320} />
      <Heading>
        <FormattedMessage id="merchant-sign-up.contract-links.thank-you" />
      </Heading>
      <Subheading>
        <FormattedMessage id="merchant-sign-up.contract-links.thanks-for-now" />
      </Subheading>
      <Button size="large" variant="primary" onClick={() => history.push('/')}>
        <FormattedMessage id="compliance.kyb.success.back-to-front-page" />
      </Button>
    </Root>
  );
};

export default Thanks;
